import React, { useState } from "react";
import { toast } from "sonner";
import { CalendarDays, Loader2 } from "lucide-react";
import { vendorServiceAvailability } from "@/lib/vendorApi";

const istToday = () => new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10);
const maxDay = () => new Date(Date.now() + 5.5 * 3600000 + 365 * 86400000).toISOString().slice(0, 10);

// Customer-facing text; past dates fall back to plain "Unavailable" (status never auto-flips).
export const availableFromText = (svc) => {
  if (svc?.available !== false || !svc.available_from || svc.available_from < istToday()) return "";
  const d = new Date(`${svc.available_from}T00:00:00+05:30`).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata" });
  return `Available from ${d}`;
};

export default function ServiceAvailableFrom({ svc, onSaved, formatApiError }) {
  const [val, setVal] = useState(svc.available_from || "");
  const [busy, setBusy] = useState(false);
  const save = async (date) => {
    setBusy(true);
    try {
      await vendorServiceAvailability(svc.id, false, date || null);
      toast.success(date ? "Available-from date save ho gayi" : "Date hata di — sirf 'Unavailable' dikhega");
      onSaved?.();
    } catch (e) { toast.error(formatApiError ? formatApiError(e) : "Save nahi ho paya"); } finally { setBusy(false); }
  };
  const stale = svc.available_from && svc.available_from < istToday();
  return (
    <div className="mt-2 rounded-lg border border-amber-200 bg-amber-50/60 p-2" data-testid={`service-available-from-${svc.id}`}>
      <label className="flex items-center gap-1 text-[11px] font-semibold text-amber-800" htmlFor={`avf-${svc.id}`}>
        <CalendarDays className="w-3.5 h-3.5" /> Wapas kab available? (optional)
      </label>
      <div className="mt-1 flex flex-wrap items-center gap-1.5">
        <input id={`avf-${svc.id}`} type="date" value={val} min={istToday()} max={maxDay()} onChange={(e) => setVal(e.target.value)}
          className="w-full sm:w-auto sm:flex-1 min-w-0 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs min-h-[36px]" data-testid={`service-available-from-input-${svc.id}`} />
        <button onClick={() => save(val)} disabled={busy || !val || val === svc.available_from}
          className="inline-flex items-center gap-1 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-semibold px-3 min-h-[36px] disabled:opacity-50" data-testid={`service-available-from-save-${svc.id}`}>
          {busy && <Loader2 className="w-3 h-3 animate-spin" />} Save
        </button>
        {svc.available_from && (
          <button onClick={() => { setVal(""); save(null); }} disabled={busy}
            className="rounded-full border border-slate-200 bg-white text-xs font-semibold text-slate-600 px-3 min-h-[36px] hover:border-rose-300 hover:text-rose-700" data-testid={`service-available-from-clear-${svc.id}`}>
            Hatayein
          </button>
        )}
      </div>
      {stale && <p className="mt-1 text-[11px] text-rose-700" data-testid={`service-available-from-stale-${svc.id}`}>Date nikal gayi — service abhi bhi Unavailable hai. Taiyaar hon to "Mark Available" dabayein.</p>}
    </div>
  );
}
